import { type ViewData, type ViewReplacement, type ViewUpdateInput, type ViewUpdateSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useViewCache } from './cache'

export function useUpdateView(): UpdateHookResponse<ViewReplacement, ViewData> {
  const cache = useViewCache()
  const mutation = useTantalimMutation<ViewUpdateInput, ViewUpdateSuccess>({ url: '/view/update' })

  async function update(view: ViewReplacement): Promise<ViewData> {
    const output = await mutation.mutateAsync({ view })
    await cache.set(output.view)
    return output.view
  }

  return mutationUpdate(mutation, update)
}
